// If you add a new dependency to this list on the top,
// consider whether you also should add it to makeSoy.js
// (i.e., whether generating the soy template now depends
//  on that file being present)
goog.require('el8.appservice.highlighter');
goog.require('el8.appservice.status');
goog.require('el8.service.tz');
goog.require('el8.shared.util.renderGrowthChart');
goog.require('el8.shared.util.hmReminder');
goog.require('el8.util.base');
goog.require('el8.util.consts');
goog.require('el8.util.datecompare');
goog.require('el8.util.print');

// Whenever you add a new printout, it has to be goog.require'd here
goog.require('el8.template.passport.print');
goog.require('el8.template.print.bulkLetter');
goog.require('el8.template.print.cardiacOrder');
goog.require('el8.template.print.demog');
goog.require('el8.template.print.growthChart');
goog.require('el8.template.print.headerPreview');
goog.require('el8.template.print.imagingOrder');
goog.require('el8.template.print.immunizationHistory');
goog.require('el8.template.print.invoice');
goog.require('el8.template.print.labOrder');
goog.require('el8.template.print.letter');
goog.require('el8.template.print.medsList');
goog.require('el8.template.print.messageThreads');
goog.require('el8.template.print.nonvisitNote');
goog.require('el8.template.print.patientInstructions');
goog.require('el8.template.print.patientVisitSummary');
goog.require('el8.template.print.ptActivationCode');
goog.require('el8.template.print.pulmonaryOrder');
goog.require('el8.template.print.referralOrder');
goog.require('el8.template.print.refPanel');
goog.require('el8.template.print.report');
goog.require('el8.template.print.rxDownloadSummary');
goog.require('el8.template.print.sleepOrder');
goog.require('el8.template.print.visitNote');
goog.require('el8.template.print.paymentCharge');

function maybeAddProtocol(string) {
    if (!string.includes('http')){
        return "http://" + string
    } else {
        return string
    }
}

var el8 = el8 || {};
if (!el8.main) { el8.main = {}; }
el8.main.printout = {};

el8.main.printout.init = function(spec) {
    el8.appservice.status.init();

    var executeFn = function(fnName, context /*, args */) {
        var args = Array.prototype.slice.call(arguments).splice(2);
        var namespaces = fnName.split('.');
        var func = namespaces.pop();
        context = context || window;
        for (var i =0; i<namespaces.length; i++) {
            context = context[namespaces[i]];
        }
        return context[func].apply(this, args);
    };

    var tmplArgs = spec.data;

    // cqmStatus data should stay underscore
    // because we have a lot of logic in hmReminder.calculateHMReminders
    // that expects the json to be underscored.
    // a small hack to keep cqmStatus unchanged
    var cqmStatus = spec['data']['cqmStatus'];
    tmplArgs['now'] = el8.service.tz.soyStr(el8.service.tz.now());
    tmplArgs = el8.util.keysFromUnderscoreToCamel(tmplArgs);

    // run a bunch of FE logic to calculate HM reminders
    var now = Date.now();
    tmplArgs['hmReminders'] = (cqmStatus ? el8.shared.util.hmReminder.calculateHMReminders(cqmStatus, now) : []);
    var regex = new RegExp("(https?:\\/\\/(?:www\\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\\.[^\\s]{2,}|www\\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\\.[^\\s]{2,}|https?:\\/\\/(?:www\\.|(?!www))[a-zA-Z0-9]\\.[^\\s]{2,}|www\\.[a-zA-Z0-9]\\.[^\\s]{2,})",'g');
    function link(value){return '<a href="' + maybeAddProtocol(value) + '">' + value + '</a>'};
    var generatedHTML = executeFn(spec.template, window, tmplArgs);
    if (spec.template === "el8.template.print.bulkLetter.content") {
        var generatedHTMLDOM = $(generatedHTML);
        $(generatedHTMLDOM).find('.el8Preserve')[0].innerHTML = $(generatedHTMLDOM).find('.el8Preserve')[0].innerHTML.replace(regex, link);
        $('.printout-content').replaceWith(generatedHTMLDOM[0].outerHTML);
    } else {
        $('.printout-content').replaceWith(generatedHTML);
    }
    // Growth charts need to run an extra, non-soy function to convert the data into a chart.
    // It's a bit of a hack to just check if we need to render growth charts for every printout.
    if (tmplArgs['growthCharts'] && tmplArgs['growthCharts'].length && $('.chart-holder').length) {
        for (var i=0; i < tmplArgs['growthCharts'].length; i++) {
            var $chartHolder = $('.chart-holder[data-index="'+i+'"]');
            el8.shared.util.renderGrowthChart(tmplArgs['growthCharts'][i], $chartHolder, true);
        }
    }

    el8.util.print.pageSetup();

};
